document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("trackOrderForm").addEventListener("submit", async function (e) {
    e.preventDefault();

    const orderNumber = document.getElementById("orderNumber").value.trim();
    const errorEl = document.getElementById("errorMessage");

    if (orderNumber === "") {
      errorEl.textContent = "⚠️ Please enter your order number.";
      return;
    }

    try {
      const response = await fetch(
        `https://azureofficial-pk.myshopify.com/admin/api/2025-07/orders.json?name=${orderNumber}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Access-Token": "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" 
          }
        }
      );

      const data = await response.json();
      console.log(data, "da=ta")

      if (!data.orders || data.orders.length === 0) {
        errorEl.textContent = "❌ Order not found.";
        return;
      }

      const order = data.orders[0]; 
      const orderId = order.id;
      const trackingUrl = order.fulfillments?.[0]?.tracking_url;

      if (trackingUrl) {
        window.location.href = trackingUrl; 
      } else {
        errorEl.textContent = "Tracking information not available yet.";
      }
    } catch (err) {
      console.error(err);
      errorEl.textContent = "⚠️ Something went wrong. Please try again.";
    }
  });
});
